<template>
    <div class="auto-list form-control">
        <input type="hidden" name="company_id" :value="entity.id" />
        <input :id="id" name="company_name" type="text" class="form-control popup-input" autocomplete="off"
               v-model="query" @focus="blankEntry = false" @blur="checkBlankEntry()" :placeholder="placeholder" :readonly="disableEntry" />
        <div v-if="blankEntry">
            <span class="popup-alert error">Company not created. <a class="company-create" @click="createEntity()">Click here to create.</a></span>
        </div>
        <div v-if="entMsg">
            <span class="popup-alert success" v-if="entMsg === 'created'"><i class="icon icon-tick"></i> New Company Successfully Created</span>
            <span class="popup-alert error" v-if="entMsg === 'existing'">Existing Company</span>
            <span class="popup-alert error" v-if="entMsg === 'blank'">No name entered, company creation failed.</span>
            <span class="popup-alert error" v-if="entMsg === 'error'">There was an error creating your company. Deploy may fail.</span>
        </div>
        <span class="popup-alert error" v-if="hasError">{{ hasError }}</span>
    </div>
</template>
<script>
    import Base from './base.js';
    export default {
        mixins: [ Base ],
        props: {
            placeholder: { default: '' },
        },
        data () {
            return {
                mydata: {},
                url: '/api/company/store',
                index_name: 'company',
            }
        },
        created(){
            if ( this.entity.name === ''
                && typeof window.currentCompany !== 'undefined'
                && this.$root.setCompany
            ) {
                this.myData = window.currentCompany;
            }
            this.$root.setCompany = true;
        },
        methods: {
            error(data){
                if(typeof data.errorName !== 'undefined') {
                    if(data.errorName === this.errorName) {
                        if(typeof data.errors['company.id'] !== 'undefined'){
                            this.hasError = data.errors['company.id'][0];
                        }
                    }
                }
            },
            entityName(item) {
                return item.name;
            }
        }
    }
</script>